// @ts-nocheck
import pxStringToNumber from "@store/Framework/Common/Utilities/pxStringToNumber";

export default (pxValueArray: (string | null)[]) => {
    return pxValueArray.map(x => pxStringToNumber(x));
};
